module.exports = __webpack_public_path__ + "img/salelinkbg.fa287660.png";